import { render, staticRenderFns } from "./gatorz-frame-specs.vue?vue&type=template&id=5ab129ec&scoped=true&"
import script from "./gatorz-frame-specs.vue?vue&type=script&lang=js&"
export * from "./gatorz-frame-specs.vue?vue&type=script&lang=js&"
import style0 from "./gatorz-frame-specs.vue?vue&type=style&index=0&id=5ab129ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab129ec",
  null
  
)

export default component.exports